import script from "./myReviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./myReviewPage.vue?vue&type=script&setup=true&lang=js"

import "./myReviewPage.vue?vue&type=style&index=0&id=7fde74e1&scoped=true&lang=scss"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fde74e1"]])

export default __exports__